import { render, staticRenderFns } from "./DocumentsPaidServices.vue?vue&type=template&id=6c6ec46f"
import script from "./DocumentsPaidServices.vue?vue&type=script&lang=js"
export * from "./DocumentsPaidServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports